import { render, staticRenderFns } from "./item_facilitator_item_table.vue?vue&type=template&id=1a5be41f&scoped=true&"
import script from "./item_facilitator_item_table.vue?vue&type=script&lang=js&"
export * from "./item_facilitator_item_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5be41f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
